<template>
  <modal v-model="value.show">
    <div slot="content">
      <div class="ls-modal-header">
        <button data-dismiss="modal" close-modal>&times;</button>
        <h4 class="ls-modal-title">{{ $root.plural(value.indexes.length, 'contracts.inactive_subscription.title') }}</h4>
      </div>
      <div class="ls-modal-body">
        <div class="ls-alert-warning">
          <strong>{{ $t('application.alert.warning') }}</strong> {{ $root.plural(value.indexes.length, 'contracts.inactive_subscription.inactive_message') }}
        </div>
        <div v-html="$root.plural(value.indexes.length, 'contracts.inactive_subscription.inactive_confirm')"></div>
      </div>
      <div class="ls-modal-footer">
        <button class="ls-btn" data-dismiss="modal" close-modal>{{ $t('application.button.close') }}</button>
        <button type="submit" class="ls-btn-danger ls-float-right" @click.prevent="destroyResource()">{{ $t('application.button.inactive') }}</button>
      </div>
    </div>
  </modal>
</template>
<script>
  import { mapMutations, mapActions } from 'vuex'
  import Modal from 'src/app/components/shareds/modal/Modal'

  export default{
    data () {
      return {
        remaining: 0,
        successIndexes: []
      }
    },
    props: ['value'],
    components: { Modal },
    mounted () {
      this.$watch('remaining', function (val) {
        if (val <= 0) {
          this.showMessages()
          this.value.stopLoading()
          this.value.callback()
        }
      })
    },
    methods: {
      ...mapMutations(['addFlash', 'clearFlash']),
      ...mapActions(['inactiveContract']),
      destroyResource () {
        this.beforeInactive()

        for (var i in this.value.indexes) {
          var index = this.value.indexes[i]
          var contract = this.value.contracts[index]

          var params = { contract: contract, index: index }
          this.inactiveContract(params).then(this.afterInactive)
        }
      },
      beforeInactive () {
        this.clearFlash()
        this.value.show = false
        this.value.startLoading()
        this.resetSuccess()
        this.setRemaining()
      },
      resetSuccess () {
        this.successIndexes = []
      },
      addSuccessIndex (index) {
        this.successIndexes.push(index)
      },
      setRemaining () {
        this.remaining = this.value.indexes.length
      },
      afterInactive (response) {
        if (response.resp.status === 200) this.addSuccessIndex(response.payload.index)
        this.remaining -= 1
      },
      showMessages () {
        if (this.value.indexes.length > 1) {
          if (this.value.indexes.length === this.successIndexes.length) {
            this.addFlash({ message: this.$t('contracts.alerts.inactivated_contracts'), type: 'ls-alert-success' })
          } else {
            this.addFlash({ message: this.$t('contracts.alerts.some_inactivated_contracts'), type: 'ls-alert-success' })
          }
        } else if (this.successIndexes.length === 1) {
          var contract = this.value.contracts[this.successIndexes[0]]
          this.addFlash({ message: this.$t('contracts.alerts.inactivated_contract', { id: contract.id }), type: 'ls-alert-success' })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ModalInactiveBatch.vue?88774e0e